import type { JSX } from 'react'
import type { IPositioningBlockProps } from '../PositioningBlock'

import { usePinnedBarBackground } from 'utils/hooks'
import { FIXED_INDENTS, NAVBAR_HEIGHT } from 'vars/index'
import { PositioningBlockPosition } from '../PositioningBlock.h'
import { HybridSearchStickyPositioningBlockSC } from './HybridSearchStickyPositioningBlock.styled'

export interface IHybridSearchStickyPositioningBlockProps extends IPositioningBlockProps {}

export const HybridSearchStickyPositioningBlock = ({
  children,
  position = PositioningBlockPosition.Sticky,
  top = NAVBAR_HEIGHT.DEFAULT,
  zIndex = 4,
  paddings = [FIXED_INDENTS.INDENT_0],
}: IHybridSearchStickyPositioningBlockProps): JSX.Element => {
  const backgroundColor = usePinnedBarBackground()

  return (
    <HybridSearchStickyPositioningBlockSC
      position={position}
      top={top}
      zIndex={zIndex}
      backgroundColor={backgroundColor}
      paddings={paddings}
    >
      {children}
    </HybridSearchStickyPositioningBlockSC>
  )
}
